import { useEffect, useState } from "react";
import { CardTaps } from "./CardTaps";
import { Alert } from "./Alert";
import { VisorAnyDocument } from "../../documents/VisorAnyDocument";

import { _DocumentFactory, _single } from "../../../core/services/dataBean/EntityCatalog";
import { PrintJson } from "./PrintJson";
import { BodegaDocumentosMenu } from "../../contabilidad/bodegaDocumentos/BodegaDocumentosMenu";
import { BackupCatalogByState } from "./BackupCatalogByState/BackupCatalogByState";


export interface DocumentPDF {
    MediaContext: string;
    Media: string;
    Filename: string;
    Type: string;
    URLLink: string | null;
}
export interface DocumentList {
    list: DocumentPDF[];
    IDDocument?: number;
    Since?: any;
}
export const DocumentViewer = ({ list, IDDocument, Since }: DocumentList) => {


    const [indexTap, setIndexTap] = useState(0);
    const [lista, setLista] = useState<any>([]);
    const [doc, setDoc] = useState<any>({});

    const [row, setRow] = useState<DocumentPDF>(undefined);
    let taps = [
        { id: 0, name: 'Documentos', disable: false },
        { id: 1, name: 'Visor', disable: list ? list.length === 0 : 0 },
        { id: 2, name: 'Historial de Cambios y Versiones', disable: list ? list.length === 0 : 0 }
    ];

    useEffect(() => {
        if (IDDocument > 0) {
            setDoc(
                {
                    IDDocument: IDDocument,
                    Since: Since
                }
            )
        }
    }, [IDDocument])

    useEffect(() => {
        if (document)
            setDoc(document);
    }, [document])



    useEffect(() => {
        if (list && Array.isArray(list)) {
            let temp = [];
            list?.forEach((element: any) => {
                if (element.DataBeanProperties) {
                    temp.push(element.DataBeanProperties);
                } else {
                    temp.push(element);
                }
            });
            setLista(temp);
        }
    }, [list])

    useEffect(() => {
        if (indexTap === 1) {

        }

    }, [indexTap])



    const vierDocument = (item: any) => {
        setRow(item);
        setIndexTap(1);
        setDoc({
            IDDocument: item.IDDocument,
            Since: item.Since
        });
        console.log("Document => ", {
            IDDocument: item.IDDocument,
            Since: item.Since
        });


    }

    return (
        <div className="row" >
            <div className="col-md-12">
                {/* <PrintJson json={doc}/> */}
                {(IDDocument && Since) &&
                    <>

                        <BodegaDocumentosMenu document={{
                            IDDocument: IDDocument,
                            Since: Since
                        }} />
                    </>
                }
            </div>
            <div className="col-md-12">
                <CardTaps taps={taps} index={indexTap} updateIndex={setIndexTap}>
                    {indexTap === 0 &&
                        <>
                            {lista.length === 0 ?
                                <Alert clase="warning">
                                    <p>No hay documentos para mostrar</p>
                                </Alert>
                                :
                                <>
                                    <div className="list-group">
                                        {lista.map((item: any, index: number) => {
                                            return (
                                                <button onClick={() => { vierDocument(item) }} key={index} type="button" className="list-group-item list-group-item-action" aria-current="true">
                                                    <i className="ri-article-line fs-2 align-middle me-2 cursor"></i>
                                                    {item.Filename}
                                                </button>
                                            )
                                        })}
                                    </div>
                                </>
                            }
                        </>
                    }
                    {indexTap === 1 &&
                        <div className="row">
                            <div className="col-md-12">
                                <VisorAnyDocument url={row?.URLLink} type={row?.Type} />
                                {/* <VisorPDF url={row.URLLink} type={row.Type} /> */}
                            </div>
                        </div>
                    }
                    {indexTap === 2 &&
                        <div className="row">
                            <div className="col-md-12">
                                <BackupCatalogByState IDDocument={IDDocument} documentDate={Since} />
                            </div>
                        </div>
                    }
                </CardTaps>
            </div>
        </div>
    )
}